(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const header = document.querySelector('[data-td-header]');
  if (!header) return;

  const count = header.querySelector('.td-header__count');
  const updateCartCount = (itemCount) => {
    if (!count || !Number.isFinite(itemCount)) return;
    count.textContent = itemCount < 100 ? String(itemCount) : '';
    count.hidden = itemCount === 0;
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    (event.promise ?? event.detail?.promise)
      ?.then(({ cart, detail }) => updateCartCount(cart?.totalQuantity ?? detail?.itemCount ?? 0))
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[td-header] Cart count update failed:', error);
      });
  });

  const toggle = header.querySelector('.td-header__menu-toggle');
  const nav = header.querySelector('.td-header__nav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  });

  if (!header.classList.contains('td-header--home')) return;
  const pageWrapper = document.querySelector('.page-wrapper');
  const desktopScrollLayout = window.matchMedia('(min-width: 990px)').matches;
  const scroller = desktopScrollLayout && pageWrapper
    ? pageWrapper
    : (document.scrollingElement || document.documentElement);
  let last = 0;
  const getTop = () => desktopScrollLayout
    ? scroller.scrollTop
    : Math.max(window.scrollY || 0, scroller.scrollTop || 0, document.body.scrollTop || 0);
  const update = () => {
    const top = getTop();
    if (top < 40) {
      header.classList.remove('td-header--hidden', 'td-header--revealed');
    } else if (top > last + 4) {
      header.classList.add('td-header--hidden');
      header.classList.remove('td-header--revealed');
    } else if (top < last - 4) {
      header.classList.remove('td-header--hidden');
      header.classList.add('td-header--revealed');
    }
    last = top;
  };
  scroller.addEventListener('scroll', update, { passive: true });
  if (!desktopScrollLayout) window.addEventListener('scroll', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-inspired"] && !Shopify.designMode) return;
  try {
    
(() => { document.querySelectorAll('[data-td-gallery]').forEach((viewport) => { const section = viewport.closest('.td-inspired'); if (!section) return; const track = section.querySelector('.td-inspired__track'); const progress = section.querySelector('[data-td-progress]'); const step = () => Math.max(viewport.clientWidth * .72, 280); section.querySelector('[data-td-prev]').addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' })); section.querySelector('[data-td-next]').addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' })); const update = () => { const max = track.scrollWidth - viewport.clientWidth; progress.style.width = `${max > 0 ? Math.max(25, Math.min(100, (viewport.scrollLeft / max) * 75 + 25)) : 100}%`; }; viewport.addEventListener('scroll', update, { passive: true }); update(); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-m2-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-td-calculator]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const input = root.querySelector('[data-area-input]');
  const result = root.querySelector('[data-result]');
  const error = root.querySelector('[data-error]');
  const packages = root.querySelector('[data-packages]');
  const covered = root.querySelector('[data-covered]');
  const price = root.querySelector('[data-price]');
  const per = Number.parseFloat(root.dataset.per) || 1.85;
  const unit = (Number.parseInt(root.dataset.price, 10) || 2731) / 100;
  const update = () => {
    const area = Number.parseFloat(String(input.value).replace(',', '.'));
    if (!Number.isFinite(area) || area <= 0) {
      result.hidden = true;
      error.hidden = input.value === '';
      return;
    }
    const count = Math.max(1, Math.ceil((area * 1.08) / per));
    packages.textContent = count;
    covered.textContent = (count * per).toLocaleString(document.documentElement.lang || 'pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    price.textContent = (count * unit).toLocaleString(document.documentElement.lang || 'pt-PT', { style: 'currency', currency: 'EUR' });
    error.hidden = true;
    result.hidden = false;
  };
  input.addEventListener('input', update);
})();

  } catch(e) { console.error(e); }
})();
})();
